import { useMemo } from "react";

import { useFlags } from "@/utils/launchDarkly";
import { isBlockedByBlockOrEventSlotAvailability } from "@/utils/slotAvailability";

export type RequestStartTimeSlotNode = Readonly<{
  id: string;
  time: string;
  availability?: string | null;
}>;

export const useFilterRequestStartTimeSlots = <
  T extends RequestStartTimeSlotNode
>(
  timeSlots: readonly (T | null)[]
): T[] => {
  const { hideUnavailableTimes } = useFlags();

  return useMemo(() => {
    const nodes = timeSlots.filter((slot): slot is T => slot != null);

    if (!hideUnavailableTimes) {
      return nodes;
    }

    return nodes.filter(
      (slot) => !isBlockedByBlockOrEventSlotAvailability(slot.availability)
    );
  }, [hideUnavailableTimes, timeSlots]);
};
